<template>
  <div>
    <van-nav-bar
      :title="$t('app.withdraw.title')"
      :left-text="$t('app.common.back')"
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    <van-row class="rowStyle" style="padding: 30px 16px 5px 16px">
      <van-col span="24" style="text-align: left">
        <span style="color: #ff0000; font-size: 15px;">{{$t("app.withdraw.accInfo")}}</span>
      </van-col>
    </van-row>
    <van-form @submit="getAccountbank">
      <van-row class="rowStyle">
        <van-col span="5" style="line-height: 20px"
          ><span>{{$t("app.withdraw.curBal")}}</span></van-col
        >
        <van-col span="19" style="text-align: left; line-height: 20px"
          ><p style="margin: 0px">
            <span>{{ cash }}</span
            >{{$t("app.common.currency")}}
          </p>
        </van-col>
        <!-- <van-col span="10" style="text-align: right"
          ><router-link to="information/withdrawal_pass"
            ><van-button
              type="info"
              style="
                height: 32px;
                padding: 0 15px;
                font-size: 14px;
                border-radius: 25px;
              "
              >修改提现密码</van-button
            ></router-link
          ></van-col
        > -->
      </van-row>
      <van-row class="rowStyle">
        <van-col span="5" style="line-height: 20px"
          ><span>{{$t("app.withdraw.exchange")}}</span></van-col
        >
        <van-col span="19" style="text-align: left; line-height: 20px"
          ><p style="margin: 0px">
            <span>{{ (cash * withdraw_exchange_ratio).toFixed(2) }}</span
            >{{$t("app.withdraw.rmb")}}
          </p>
        </van-col>
      </van-row>
      <van-row class="rowStyle">
        <!-- <van-col span="5" style="line-height: 30px"
          ><span>兑换汇率：</span></van-col
        > -->
        <van-col span="24" style="text-align: left; line-height: 20px"
          ><p style="margin: 0px">
            {{$t("app.withdraw.ratio")}}<span>1:{{ withdraw_exchange_ratio }}</span>
          </p>
        </van-col>
      </van-row>

      <van-row class="rowStyle" style="padding: 30px 16px">
        <van-col span="12" style="text-align: left">
          <span style="color: #ff0000; font-size: 15px;">{{$t("app.withdraw.currency")}}</span>
        </van-col>
        <van-col span="12" style="text-align: right">
          <router-link to="information/withdrawal_pass"
            ><span style="color: #1989fa">{{$t("app.withdraw.changePW")}}</span></router-link
          >
        </van-col>
      </van-row>
      <van-row class="labelStyle">
        <van-col span="24">
          <van-field
            v-model="money"
            type="digit"
            :label="$t('app.withdraw.amt')"
            :placeholder="$t('app.withdraw.amt_plh')"
            input-align="left"
            autocomplete="off"
            style="color: #000000; padding: 3px 16px"
          />
        </van-col>
        <!-- <van-col span="8"
          ><p style="margin: 0px; padding: 10px 0px; font-size: 14px">
            人民币
          </p></van-col
        > -->
      </van-row>
      <van-row class="labelStyle">
        <van-col span="24">

      <van-field
      v-if="selected_type==2"
         v-model="gxpay_id"
         type="digit"
         label="Gxpay ID"
         :placeholder="$t('app.withdraw.gx_plh')"
         input-align="right"
         style="color: #000000"
       >
       <template #button>
         <van-checkbox v-model="confirmChecked">{{$t("app.withdraw.verified")}}</van-checkbox>
       </template>
       </van-field>
       </van-col>
      </van-row>
      <van-row class="labelStyle">
        <van-col span="24">
          <van-field
            v-model="password"
            type="password"
            :label="$t('app.withdraw.pwd')"
            :placeholder="$t('app.withdraw.pwd_plh')"
            input-align="left"
            style="color: #000000; padding: 3px 16px;"
            autocomplete="new-password"
          />
        </van-col>
        <!-- <van-col span="8"
          ><router-link to="information/withdrawal_pass"
            ><p
              style="
                margin: 0px;
                padding: 10px 0px;
                font-size: 14px;
                color: #ee0a24;
              "
            >
              修改提现密码
            </p></router-link
          ></van-col
        > -->
      </van-row>
      <van-row v-for="(item, index) in auto_fill_amounts" :key="index">
              <van-col span="6" v-for="(item1, index1) in item" :key="index1">
                <van-button round plain hairline native-type="button" type="danger" size="normal" @click="handleAmount(item1)" style="margin-left: 15%; margin-top: 5px;">{{ item1 }}元</van-button>
              </van-col>
            </van-row>
            <!-- <div
         style="margin-left: 16px; padding-right: 12px"
         v-html="notice_1_1"
       ></div> -->
            <div style="border-left: 5px solid red; margin-left: 25px">
         <p style="margin-left: 10px">{{$t("app.withdraw.select")}}</p>
       </div>
       <van-radio-group v-model="radio">
         <van-cell-group>
           <van-row
             v-for="(item, index) in withdrawType"
             :key="index"
             clickable
             @click="changeInstructions(index, item.type)"
             style="margin-left: 16px; font-size: 14px"
           >
             <van-col span="4">
               <p style="text-align: center; margin: 2px">
                 <img style="height: 25px" src="../assets/images/recharge.jpg" />
               </p>
             </van-col>
             <van-col span="16">
               <p style="margin: 2px">{{ item.name }}</p>
             </van-col>
             <van-col span="4">
               <p style="margin: 2px"><van-radio :name="index" /></p>
             </van-col>
           </van-row>
         </van-cell-group>
       </van-radio-group>
      <van-row style="padding: 30px 16px">
        <van-col span="24">
          <van-button size="normal" type="danger" block >{{$t("app.withdraw.continue")}} {{ button_text }}</van-button>
         </van-col
        >
      </van-row>
      <van-row class="rowStyle" v-if="exchange_min_fee_rate != 0">
        <van-col span="24" style="text-align: left; line-height: 20px"
          ><p style="margin: 0px;color: #ff0000; font-size: 15px;">
            {{$t("app.withdraw.reminder_first")}}
            </p>
            <!-- <p style="margin: 0px;">
            提现手续费按照提现金额的{{ exchange_min_fee_rate }}%收取，{{
              exchange_min_fee
            }}元起。
          </p> -->
          <p>{{ withdraw_desc }}</p>
        </van-col>
      </van-row>
      <!-- <van-row
        v-if="withdraw_fee_percentage"
        class="rowStyle"
        style="border-bottom: none"
      >
        <van-col span="24" style="line-height: 25px"
          ><p style="color: red; margin: 0">温馨提醒：</p>
          <p style="margin: 0">
            提现手续费按提现金额的{{ withdraw_fee_percentage }}%收取，{{
              withdraw_fee_min
            }}元起。
          </p></van-col
        >
      </van-row> -->
    </van-form>
    <!-- ============================== Start change channel popup ========================== -->
    <van-popup
      v-model="showTradeChannelPopup"
      closeable
      id="tradingAgreePop"
      style="width: 85%"
    >
      <div
        v-html="trade_rules_content_top"
        style="overflow-y: scroll; max-height: 320px; margin: 10px"
      ></div>
      <div style="text-align: center; padding: 0px 10px">
        <van-button
          type="danger"
          size="large"
          @click="agreeTradeRules"
          style="width: 50%; height: 30%; padding: 3px; border-radius: 6px"
          >{{$t("app.withdraw.undestand")}}
        </van-button>
        <div
          v-html="trade_rules_content_bottom"
          style="text-align: center; margin: 10px"
        ></div>
      </div>
    </van-popup>
    <!-- ============================== End change channel popup ========================== -->
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { version } from "../../package";

export default {
  name: "Withdrawal",
  data() {
    return {
      cash: 0,
      money: "",
      password: "",
      popupStatus: "",
      timbaoAnulaizedInterestRate: "",
      timebaoRate: "",
      account: "",
      card: "",
      name: "",
      address: "",
      bankStatus: false,
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      // withdraw_fee_percentage: 0,
      // withdraw_fee_min: 0,
      withdraw_exchange_ratio: 1,
      exchange_amount: 0,
      exchange_fee: 0,
      exchange_min_fee_rate: 0,
      exchange_min_fee: 0,
      withdraw_desc:"",
      withdrawType: [],
       notice_1_1: "",
       notice_2_1: "",
       notice_2_2: "",
       selectedTypeId: "",
       auto_fill_amounts: [],
       radio:1,
       data: "",
       gxpay_id:'',
       selected_type:'',
       confirmChecked:false,
       button_text: null,
    };
  },
  methods: {
  
    getWithdrawTypes() {
       let that = this;
       that
         .$http({
           url: "/",
           method: "post",
           data: {
             nozzle: "withdraw_type",
             app_version: version,
             token: sessionStorage.getItem("token"),
 
           },
         })
         .then(function (res) {
           if (res.data.code == 1) {
             let resData = res.data;
             let withdrawType = resData.data;
             for (let i = 0, len = withdrawType.length; i < len; i++) {
               if (withdrawType[i].isdefault == 1) {
                 that.radio = i;
               }
             }
             that.withdrawType = withdrawType;
             let SelectedType = withdrawType[that.radio];
             that.notice_1_1 = SelectedType.notice_1_1;
             that.notice_2_1 = SelectedType.notice_2_1;
             that.notice_2_2 = SelectedType.notice_2_2;
             that.auto_fill_amounts = SelectedType.auto_fill_amounts;
             that.button_text = SelectedType.button_text;
             that.selectedTypeId = SelectedType.id;
             that.selected_type=SelectedType.type;
           } else if (res.data.code == 0 || res.data.code == -1) {
             that.$toast.fail(that.$t(res.data.msg));
           }
           
         });
     },
     changeInstructions(index, type) {
       let that = this;
       that.radio = index;
       let SelectedType = that.withdrawType[index];
       that.selectedTypeId = SelectedType.id;
       that.notice_1_1 = SelectedType.notice_1_1;
       that.notice_2_1 = SelectedType.notice_2_1;
       that.notice_2_2 = SelectedType.notice_2_2;
       that.auto_fill_amounts = SelectedType.auto_fill_amounts;
       that.selected_type=SelectedType.type;
       that.button_text = SelectedType.button_text;
       that.money = '';
       that.confirmChecked = false;
       that.getGxpayId();
     },
     getGxpayId(){
       let that = this;
       that
       .$http({
         url: "/",
         method: "post",
         data: {
           nozzle: "gxpay_thirdparty_digital_currency",
           token: sessionStorage.getItem("token")
         }
       })
       .then(function(res) {
         if (res.data.code == 1) {
           let resData = res.data;
           if(resData.data.user == true){
             that.gxpay_id = resData.data.numberId;
           }else{
             if(that.selected_type==2){
               window.open(resData.data.homeUrl,"_blank");
             that.$router.push("/member/members"); 
             }
             
 
 
           }
         }
       });
     },
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    getUser() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            that.cash = resData.data.cash;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(that.$t(resData.msg));
          }
        });
    },
    getUserInfo() {
      let that = this;
      let toast = that.$toast.loading({
        forbidClick: true,
      });
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user_info",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          toast.clear();
          if (res.data.code == 1) {
            if (res.data.data.withdrawal == 0) {
              that.showWithdrawlPassPopup();
              return;
            }
            if (res.data.data.bank == 0) {
              that.showWithdrawlBankPopup();
              return;
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        });
    },
    getWithdrawChannelInfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "withdraw_channel",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code == 1) {
            that.withdraw_desc = resData.data.withdraw_hint
            // that.withdraw_fee_percentage = resData.data.withdraw_fee_percentage;
            // that.withdraw_fee_min = resData.data.withdraw_fee_min;
            that.withdraw_exchange_ratio = resData.data.withdraw_exchange_ratio;
            that.exchange_min_fee_rate = resData.data.exchange_min_fee_rate;
            that.exchange_min_fee = resData.data.exchange_min_fee;
          } else if (res.data.code == 0 || res.data.code == -1) {
            // that.$toast.fail(resData.msg);
          }
        });
    },

    showWithdrawlPassPopup() {
      let that = this;
      Dialog.confirm({
        title: "",
        message: this.$t('app.withdraw.popup'),
        cancelButtonText: this.$t('app.common.cancel'),
        confirmButtonText: this.$t('app.common.confirm'),
      })
        .then(() => {
          that.$router.push({ name: "WithdrawalPass" });
        })
        .catch(() => {
          that.$router.go(-1);
        });
    },
    showWithdrawlBankPopup() {
      let that = this;
      Dialog.confirm({
        title: "",
        message: this.$t('app.withdraw.popup2'),
        cancelButtonText: this.$t('app.common.cancel'),
        confirmButtonText: this.$t('app.common.confirm'),
      })
        .then(() => {
          that.$router.push({ name: "BindBank" });
        })
        .catch(() => {
          that.$router.go(-1);
        });
    },
    //查询提现是否有银行卡
    getAccountbank() {
      let that = this;
      let radio = that.withdrawType[that.radio].type; 
      if (that.money == "") {
        that.$toast.fail(this.$t('app.withdraw.warn1'));
        return false;
      } else if (that.password == "") {
        that.$toast.fail(this.$t('app.withdraw.warn2'));
        return false;
      }
      else if(radio == 2 && (that.gxpay_id=="" || that.gxpay_id==undefined)){
         that.$toast.fail(this.$t('app.withdraw.warn3'));
         return false;
       } else if(radio == 2 && that.confirmChecked == false){
         that.$toast.fail(this.$t('app.withdraw.warn4'));
         return false;
       }
      let toast = that.$toast.loading({
        forbidClick: true,
      });
      switch (radio) {
         case 2:
         toast.clear();
           that.withdraw_has();
           break;
         default:
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "accountbank",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          toast.clear();
          let resData = res.data;
          if (res.data.code == 1) {
            if (resData.data.length === 0) {
              that.$toast({
                type: "fail",
                message: that.$t('app.withdraw.bankb'),
                onClose: function () {
                  that.$router.push("/member/information");
                },
              });
            } else {
              that.bankCardList = resData.data;
              that.account = that.bankCardList[0].account;
              that.card = that.bankCardList[0].card;
              that.name = that.bankCardList[0].name;
              that.address = that.bankCardList[0].address;
              that.withdraw_has();
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        })
        .catch(() => {
          that.$toast.fail(that.$NoNetworkErrorMsg);
        });
        break;
       }
    },

    withdraw_has() {
      let that = this;
      let number = parseInt(that.money);
      let toast = that.$toast.loading({
        forbidClick: true,
      });
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "withdraw_has",
            token: sessionStorage.getItem("token"),
            number: number,
          },
        })
        .then(function (res) {
          toast.clear();
          let resData = res.data;
          if (resData.code == 0) {
            // that.withdrawal();
            that.WithdrawPopup();
          } else {
            Dialog.confirm({
              title: "",
              message:
                this.$t('app.withdraw.same'),
              cancelButtonText: this.$t('app.withdraw.cancel'),
              confirmButtonText: this.$t('app.withdraw.confirm'),
            })
              .then(() => {
                that.WithdrawPopup();
              })
              .catch(() => {});
          }
        })
        .catch(() => {
          that.withdrawal();
        });
    },

    WithdrawPopup() {
      let that = this;
      let toast = that.$toast.loading({
        forbidClick: true,
      });
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            action: "withdraw_popup",
          },
        })
        .then(function (res) {
          toast.clear();
          if (res.data.code == 1) {
            that.popupStatus = res.data.data.is_withdraw_popup;
            that.timbaoAnulaizedInterestRate =
              res.data.data.timebao_annualized_interest_rate;
            that.timebaoRate = res.data.data.timebao_rate;
            that.secondWithdrawalPopup();
          } else if (res.data.code == 0) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        })
        .catch(() => {
          that.withdrawal();
        });
    },

    secondWithdrawalPopup() {
      let that = this;
      if (that.popupStatus == 1) {
        Dialog.confirm({
          title: this.$t('app.withdraw.reminder'),
          message:
            this.$t('app.withdraw.reminder1') +
            that.timebaoRate +
            this.$t('app.withdraw.reminder2') +
            that.timbaoAnulaizedInterestRate +
            "%",
          cancelButtonText: this.$t('app.withdraw.reminder3'),
          confirmButtonText: this.$t('app.withdraw.reminder4'),
          cancelButtonColor: "#ee0a24",
        })
          .then(() => {
            that.withdrawal();
          })
          .catch(() => {
            that.$router.push("/member/time_bao");
          });
      } else {
        that.withdrawal();
      }
    },
    handleAmount(amount){
      let that = this;
      that.money = amount;
    },
    //提现
    withdrawal() {
      let that = this;
      let withdraw = that.withdrawType[that.radio];
      if (that.money == "") {
        that.$toast.fail(this.$t('app.withdraw.warn1'));
        return false;
      } else if (that.password == "") {
        that.$toast.fail(this.$t('app.withdraw.warn2'));
        return false;
      } 
      else if (withdraw.type == 2 && that.gxpay_id=="") {
          that.$toast.fail(this.$t('app.withdraw.warn3'));
        return false;  
      }
      else if(withdraw.type == 2 && that.confirmChecked == false){
         that.$toast.fail(this.$t('app.withdraw.warn4'));
         return false;
       }
      else {
        let toast = that.$toast.loading({
          forbidClick: true,
        });
        switch (withdraw.type) {
         case 2:
       
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "withdraw",
              token: sessionStorage.getItem("token"),
              number: that.money,
              password: that.password,
              id:withdraw.id,
              type:withdraw.type,
              gxpay_id:that.gxpay_id
            },
          })
          .then(function (res) {
            toast.clear();
            if (res.data.code == 1) {
              that.$toast.success({
                message: that.$t('app.withdraw.success'),
                type: "success",
                onClose: function () {
                  that.$router.push("/member/detailed_log");
                },
              });
            } else if (res.data.code == 2){
              that.getTradeChannel();
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(that.$t(res.data.msg));
            }
          })
          .catch(() => {
            that.$toast.fail(that.$NoNetworkErrorMsg);
          });
          break;
          default:
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "withdraw",
              token: sessionStorage.getItem("token"),
              number: that.money,
              password: that.password,
              name: that.name,
              card: that.card,
              id:withdraw.id,
              type:withdraw.type
            },
          })
          .then(function (res) {
            toast.clear();
            if (res.data.code == 1) {
              that.$toast.success({
                message: that.$t('app.withdraw.success'),
                type: "success",
                onClose: function () {
                  that.$router.push("/member/detailed_log");
                },
              });
            } else if (res.data.code == 2){
              that.getTradeChannel();
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(that.$t(res.data.msg));
            }
          })
          .catch(() => {
            that.$toast.fail(that.$NoNetworkErrorMsg);
          });
          break;

        }
      }
    },
    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      Toast.loading();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            Toast.clear();
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
            Toast.clear();
            // that.$toast.fail(res.data.msg);
          }
        });
    },

    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: that.$t(res.data.msg),
            });
            that.showTradeChannelPopup = false;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        });
    },
  },
  watch: {
    money: function (val) {
      if (val > 0) {
        var ex_fee = 0;
        var min_fee = 0;
        if (this.exchange_min_fee_rate > 0) {
          ex_fee = (val * this.exchange_min_fee_rate) / 100;
          min_fee = this.exchange_min_fee;
        }
        this.exchange_fee = ex_fee >= min_fee ? ex_fee : min_fee;
        return;
      } else {
        this.exchange_fee = 0;
        return;
      }
    },
  },
  mounted: function () {
    this.isLogin();
    this.getUser();
    this.getUserInfo();
    this.getWithdrawChannelInfo();
    this.getWithdrawTypes();
     this.getGxpayId();
  },
};
</script>

<style scoped>
.rowStyle {
  padding: 0px 16px;
  /* border-bottom: 1px solid #ebedf0; */
  font-size: 14px;
}
</style>

<style>
#tradingAgreePop p {
  margin: 0 !important;
}

#tradingAgreePop .van-popup__close-icon--top-right {
  top: 0px;
  right: 0px;
}

.labelStyle .van-field__label{
  color: #000000;
}
</style>


// WEBPACK FOOTER //
// src/components/Withdrawal.vue